import {url} from '@app/utils';

const {deserializeQs} = url;
// TODO(rupertrutland): test this.
export function getConfirmCode(hashString) {
    return deserializeQs(hashString, '#').code;
}
